import React from 'react';
import styled from 'styled-components';
import { typography, color } from 'styled-system';
const StyledSvg = styled('svg')(typography, color);

const Location = props => (
  <StyledSvg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.082 2.973a9.905 9.905 0 00-14.151 0c-3.908 3.965-3.908 10.392 0 14.356l6.214 6.317a1.17 1.17 0 001.675 0l6.262-6.376c3.89-3.948 3.89-10.349 0-14.297zM17.395 15.56l-5.389 5.491-5.389-5.491C3.644 12.54 3.646 7.648 6.62 4.63a7.541 7.541 0 0110.772 0c2.975 3.017 2.976 7.909.003 10.928zm-8.927-9.08a5.221 5.221 0 000 7.297 5.03 5.03 0 005.516 1.132c1.895-.784 3.142-2.644 3.164-4.72a5.11 5.11 0 00-1.486-3.65 5.036 5.036 0 00-3.585-1.548A5.033 5.033 0 008.468 6.48zM14 12.077a2.718 2.718 0 01-3.472.37A2.81 2.81 0 019.5 9.062a2.74 2.74 0 013.077-1.675c1.288.26 2.215 1.408 2.212 2.74a2.806 2.806 0 01-.849 1.95H14z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </StyledSvg>
);
export default Location;
